export const getSubmittingStatus = state => state.cyberSourceData && state.cyberSourceData.isSubmitting;

export const areVendorsLoaded = state => !!state.cyberSourceData?.data?.cardinalToken;

export const areVendorsReady = state => !!state.cyberSourceData?.data?.cardinalSessionId;
